<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">澳门数字新经济论坛成功举办 助力未来数字产业高质量发展</h1>
                    <div class="title-info">2022-05-12</div>
                    <div class="main-content">
                        &emsp;&emsp;本报讯(记者 罗铭萱)5月11日下午，澳门数字新经济论坛以线上形式召开。本次研讨会由澳门品质品牌国际认证联盟主办，旨在回应《粤港澳大湾区发展规划纲要》《横琴粤澳深度合作区建设总体方案》等中央计划，依托国家级区块链新型基础设施“星火·链网”，共同探索澳门数字经济的发展和数字贸易相关的规划。<br>
<br>
&emsp;&emsp;澳门特别行政区经济及科技发展局科技厅厅长谢永强，中国资讯通信研究院工业互联网与物联网研究所副所长李海花，全国人大代表、澳门工商联会会长何敬麟，浪潮集团副总裁、浪潮工业互联网总经理庞松涛，澳门城市大学数据科学教授蔡智明，光联集团产品总监刘超，澳门品质品牌国际认证联盟理事长冯文滔，浪潮工业互联网华南中心总经理乌苏晋，中国资讯通信研究院工业互联网与物联网研究所粤澳合作筹备人郝献举等领导专家参与了本次会议。<br>
<br>
&emsp;&emsp;除此以外，澳门政府经济及科技发展局、澳门贸易投资促进局、澳门科学技术发展基金、澳门国际青年智库、澳门邮电局、横琴粤澳深度合作区经济发展局、澳门生产力暨科技转移中心、澳门科学技术发展基金会、澳门品质品牌国际认证联盟、澳门融贯科技投资有限公司、浪潮集团、南光集团、光联集团、澳门工商联合会、澳门中华总商会青委会科技资讯部、澳门厂商联合会青委会、澳门产业区块链协会、清华珠三角研究院等派代表参与本次听会。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034159_94111.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;澳门数字新经济论坛与会照片(郑杰骏摄)<br>
<br>
&emsp;&emsp;会议伊始，澳门特别行政区经济及科技发展局科技厅厅长谢永强，中国资讯通信研究院工业互联网与物联网研究所副所长李海花，澳区人大代表、澳门工商联会会长何敬麟及浪潮集团副总裁庞松涛发表致辞。<br>
<br>
&emsp;&emsp;澳门特别行政区政府经济及科技发展局科技厅厅长谢永强致词时表示，《横琴粤澳深度合作区建设总体方案》第十九条明确阐述，“支持珠海、澳门相关高校、科研机构在确保个人资讯和重要数据安全前提下，实现科学研究数据跨境互联互通”，这为澳门发展数字经济、数字贸易提供了重要契机。澳门经科局也一直通过在推广、研究、落地三个方面的努力，积极支持澳门各机构、各企业用好、用足包括区块链在内的创新科技工具，鼓励各科技项目的产学研合作，为夯实琴澳两地的合作与提升澳门数字经济发展水准而努力。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034213_76509.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;澳门特别行政区政府经济及科技发展局科技厅厅长谢永强(郑杰骏摄)<br>
<br>
&emsp;&emsp;中国资讯通信研究院工业互联网与物联网研究所副所长李海花表达了信通院对澳门数字经济前景与未来数据价值的高度肯定。数字经济是实体经济和资讯通信技术深度融合的必然产物，作为数字经济发展的基本，基础设施建设的重要性毋庸置疑。近年来，由信通院牵头建设的“星火·链网”横琴节点得到了中央和工信部的高度重视，在同各行业与企业的合作下，澳门骨干节点建设目前已取得良好成效。在后续的发展中，信通院希望澳门能够依托区位优势、把握全球发展机遇，满足澳门数字经济贸易进一步发展和数据开放共用的需求。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034224_19417.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;中国资讯通信研究院工业互联网与物联网研究所副所长李海花(郑杰俊摄)<br>
<br>
&emsp;&emsp;澳区人大代表、澳门工商联会会长何敬麟指出，在中共中央、国务院《关于加快建设全国统一大市场的意见》对统一市场底层运行的标准和约束中，“星火·链网”等新一代资讯技术将发挥更大作用。依托“星火·链网”在澳门建设横贯全国、畅通无阻的数字经济网路将为湾区资本、劳动力、能源、生态的统一铺设网路基础，增强产业协同运作的精准性，推动澳门数字经济产业实现可持续、高质量的发展。澳门品牌品质国际认证联盟希望通过本次交流会，组织行业的统筹单位、领军企业、学术研究机构及专家，为澳门数字经济发展出谋献策。<br>
<br>
&emsp;&emsp;浪潮集团副总裁庞松涛表示，在过去一年里，依托浪潮云洲工业互联网平台的标识解析及区块链技术建设的“星火·链网”横琴骨干节点服务于中药材、茶叶、金融、民生等数字贸易场景，为澳门产业多元发展创造了有利条件；创新应用“澳优码”的推出提供了一码溯源、品质保障、数字行销、价值回馈等多重服务，在增强澳门国际数字贸易影响力的同时，有力推进了粤澳区域一体化的发展。浪潮集团希望今后能在云网技术层面为“星火·链网”的建设提供进一步支持，促进澳门数字经济产业集群高质量发展，为粤港澳大湾区建设发挥示范引领作用和助推粤澳地区链网协同高质量发展建设做出贡献。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034236_15165.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;浪潮集团副总裁庞松涛(郑杰骏摄)<br>
<br>
&emsp;&emsp;随后，受邀嘉宾就“星火·链网”应用的不同领域进行主题分享。<br>
<br>
&emsp;&emsp;首先，中国资讯通信研究院工业互联网与物联网研究所副所长李海花介绍了目前“星火·链网”的建设进展。李海花副所长指出，作为“制造强国”与“网路强国”战略下的国家级区块链基础设施，“星火·链网”现已初步形成对产业的带动效应及技术、产品、活动相结合的生态推动体系，并开始布局大场景设计，赋能区块链产业发展。作为星火·链网国际网路部署和跨境贸易的桥头堡，澳门将朝打造超级节点的方向努力，与其他国际节点一起形成面向RCEP的跨境区块链服务网络。<br>
<br>
&emsp;&emsp;澳门品质品牌国际认证联盟秘书长陈祥分享了澳优码应用的实践效果。在标准、认证、溯源、运营、监管、信用六大体系的支持下，澳优码平台向政府和企业提供了包括品牌、服务、监管、运营在内的区域品牌服务。参考广西粤桂国际茶业交易中心和广州茶叶国际交易中心已形成的完整贸易模式，“星火·链网”及其下的澳优码应用能够有效解决后疫情时代产业的数位化升级问题，为当前澳门发展欣欣向荣的茶叶和中药产业提供定制化的数字升级服务。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034247_78486.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;澳门品质品牌国际认证联盟秘书长陈祥(闫洪纲摄)<br>
<br>
&emsp;&emsp;澳门城市大学数据科学教授蔡智明展开了对跨境数据的法规、技术与文化的探讨。蔡智明教授在关于大陆、澳门及欧洲、南美洲葡语国家跨境数据的相关法规的对比中总结出了澳门在跨境数据流通中获得外方充分性认定的法律优势。加上手握一国两制的制度优势及多元文化、跨文化互信、中葡平台的文化优势，澳门正逢可获各方最大公约信任的历史机遇，因此应利用好澳门优势，发展跨境协同计算技术，以保证内地的互联网运作的安全和可持续。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034300_21955.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;澳门城市大学数据科学教授蔡智明(郑杰骏摄)<br>
<br>
&emsp;&emsp;浪潮工业互联网华南中心总经理乌苏晋介绍了“星火·链网”链上自贸的发展进度。浪潮打造的云州链平台打破了传统的数字鸿沟，为“星火·链网”各节点提供了稳定的区块链和标识解析融合服务，实现了对区块链的统一服务与监管。“星火·链网”预计将充分发挥区块链技术优势及基础设施能效，有力推动数字贸易发展，加快各行业数位化转型，强化政府数字治理能力，增强澳门数字新经济的发展动能。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034312_19249.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;浪潮工业互联网华南中心总经理乌苏晋(郑杰骏摄)<br>
<br>
&emsp;&emsp;光联集团产品总监刘超就数字经济下新基建——智能网路构建方案提出了建设性意见。刘超总监表示，在数字经济时代，企业网路正面临包括带宽需求激增、组网场景多样、网路运维复杂等在内的系列挑战。结合云网融合的主流趋势，光联集团致力于帮助企业构建弹性网路，从资源、技术、网路服务三方面提供多层次的解决方案，助力企业在降本、增效的基础上实现数位化转型。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034324_46601.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;光联集团产品总监刘超(郑杰骏摄)<br>
<br>
&emsp;&emsp;充分听取各方代表的发言后，与会嘉宾就澳门数字经济的发展问题展开了进一步探讨。李海花副所长就全球互联趋势和澳门区位优势层面解答了创业者如何融入澳门数字新经济发展的问题，乌苏晋总经理与刘超总监则站在浪潮集团与光联集团的立场上对澳门和横琴粤澳深度合作区的发展发表了相关见解。<br>
<br>
&emsp;&emsp;<img src="/core/extend/kindeditor/attached/image/20220605/20220605034334_67413.jpg" alt="" ondragstart="return false"><br>
<br>
&emsp;&emsp;澳门品质品牌国际认证联盟理事长冯文滔(闫洪纲摄)<br>
<br>
&emsp;&emsp;最后，澳门品质品牌国际认证联盟理事长冯文滔发表总结致辞。冯文滔表示，处于百年大变局和严峻的疫情形势下，澳门经济将往何处发展是一个亟待解答的问题。手握“一中心、一平台、一基地”的定位优势，澳门具有极大的政策灵活性和区域化发展空间。冯文滔希望以国家规划标准为抓手、以数位化为工具，利用“星火·链网”等新技术推动澳门成为中国与国际对接的交汇点，推动数字贸易发展及产业数位化转型，为澳门带来更多新业态，实现澳门产业多元的愿景。同时，冯文滔表示在6月份，将会举办专门的“澳优码”应用场景发布会，到时将系统性的跟大家汇报粤澳链在多个应用场景上的探索和成绩。(责任编辑：吴从周)<br>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/59" ondragstart="return false">上一条 :  “星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴</a>
                        <a href="/NewsDetail/57" ondragstart="return false">下一条 : 湾区青年说丨粤港澳三地青年畅谈湾区故事</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>